import { signOut } from "firebase/auth";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { auth, db } from "../Backend/Firebase.js";

// Handle Sign-Out
export const handleSignOut = async (onSignOut) => {
  try {
    await signOut(auth);
    onSignOut(); // Notify parent component
  } catch (error) {
    console.error("Error signing out:", error);
  }
};

// Add user data to Firestore if not present
export const checkAndStoreUserData = async (user) => {
  const userRef = doc(db, "users", user.uid);
  const userDoc = await getDoc(userRef);

  if (!userDoc.exists()) {
    if (user && user.displayName && user.email) {
      const displayNameParts = user.displayName.split(" ");
      const firstName = displayNameParts[0] || ""; // First part of the display name or empty
      const lastName = displayNameParts.slice(1).join(" "); // Remaining parts as last name, can be empty

      // Preset sync may create the document while profile setup is in flight.
      // Merge profile fields so that setup cannot erase newly synced presets.
      await setDoc(userRef, {
        firstName, // Allow empty first name
        lastName, // Allow empty last name
        emailId: user.email, // Email is required
        registrationDate: new Date().toISOString(),
        isUserActive: true,
      }, { merge: true });

      //   console.log("User added to Firestore:", user.email);
    } else {
      console.error(
        "User data is incomplete or missing. Cannot add to Firestore."
      );
    }
  }
};
